import { Navigate } from "react-router-dom";
import { getProofOfIncomeScreen } from "./proofOfIncomeScreen";

export function ProofOfIncomeTurn() {
  return <Navigate to={getProofOfIncomeScreen()} replace />;
}
